import { dbAdapter } from './databaseAdapter';
import { inventoryService } from './inventoryService';
import { customerService } from './customerService';

export const transactionService = {
  // GET ALL
  getAll: async () => dbAdapter.get('transactions'),
  
  // GET BY ID
  getById: async (id) => dbAdapter.getById('transactions', id),
  
  // GET BY WORK ORDER
  getByWorkOrder: async (workOrderId) => {
    const transactions = await dbAdapter.get('transactions');
    return transactions.filter(t => t.workOrderId === workOrderId);
  },
  
  // GET BY CUSTOMER
  getByCustomer: async (customerId) => {
    const transactions = await dbAdapter.get('transactions');
    return transactions.filter(t => t.customerId === customerId);
  },

  // CREATE — SEMUA DIBULATKAN!
  // CREATE — PAKE DATA DARI workOrderService, JANGAN HITUNG ULANG!
create: async (data) => {
  console.log('📤 [CREATE] Received data:', data);
  
  //PASTIKAN ITEMS PUNYA TOTAL
  const items = (data.items || []).map(item => ({
    ...item,
    total: (item.quantity || 0) * (item.price || 0)
  }));
  
  //PAKE DATA DARI workOrderService, JANGAN HITUNG ULANG!
  const newTransaction = {
    id: `TRX-${Date.now()}`,
    workOrderId: data.workOrderId,
    customerId: data.customerId,
    date: data.date || new Date().toISOString(),
    items: items,
    subtotal: Math.round(data.subtotal || 0),
    discount: Math.round(data.discount || 0),
    discountPercent: Math.round(data.discountPercent || 0),
    markup: Math.round(data.markup || 0),
    markupPercent: Math.round(data.markupPercent || 0),
    tax: Math.round(data.tax || 0),
    taxPercent: Math.round(data.taxPercent || 0),
    taxName: data.taxName || 'PPN',
    total: Math.round(data.total || 0),
    paymentMethod: data.paymentMethod || 'cash',
    paymentStatus: data.paymentStatus || 'pending',
    paymentDate: data.paymentStatus === 'paid' ? new Date().toISOString() : null,
    notes: data.notes || '',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  };
  
  console.log('📤 [CREATE] New transaction:', newTransaction);
  
  // Update inventory stock
  if (newTransaction.paymentStatus === 'paid') {
    for (const item of items) {
      try {
        await inventoryService.removeStock(
          item.inventoryId || item.id, 
          item.quantity, 
          `Used in transaction ${newTransaction.id}`
        );
      } catch (error) {
        console.error('Error updating stock:', error);
      }
    }
  }
  
  // Update customer stats
  if (newTransaction.customerId) {
    await customerService.updateStats(newTransaction.customerId);
  }
  
  return dbAdapter.create('transactions', newTransaction);
},
  
  // UPDATE — SEMUA DIBULATKAN!
  update: async (id, data) => {
  try {
    console.log('📤 [transactionService.update] Data masuk:', data);
    const updates = {
      ...data,
      updatedAt: new Date().toISOString()
    };
    console.log('📤 [transactionService.update] Updates:', updates);
    return await dbAdapter.update('transactions', id, updates);
  } catch (error) {
    console.error('Error updating transaction:', error);
    throw new Error(error.message || 'Gagal mengupdate transaksi');
  }
},
    
  // UPDATE PAYMENT STATUS
  updatePaymentStatus: async (id, status, paymentDate = null) => {
  try {
    //AMBIL DATA TRANSAKSI YANG ADA
    const transaction = await dbAdapter.getById('transactions', id);
    if (!transaction) {
      throw new Error('Transaksi tidak ditemukan');
    }
    
    //HITUNG ULANG TAX KALO STATUS JADI PAID (TAPI PAKE DATA LAMA)
    let updates = {
      paymentStatus: status,
      paymentDate: paymentDate || new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    //KALO STATUS JADI 'paid', PASTIKAN SUBTOTAL & TOTAL TETAP
    if (status === 'paid') {
      updates = {
        ...updates,
        subtotal: transaction.subtotal || 0,
        discount: transaction.discount || 0,
        discountPercent: transaction.discountPercent || 0,
        markup: transaction.markup || 0,
        markupPercent: transaction.markupPercent || 0,
        tax: transaction.tax || 0,
        taxPercent: transaction.taxPercent || 0,
        taxName: transaction.taxName || 'PPN',
        total: transaction.total || 0
      };
    }
    
    console.log('📤 [updatePaymentStatus] Updates:', updates);
    
    const result = await dbAdapter.update('transactions', id, updates);
    
    //UPDATE WO KALO TRANSAKSI PAID!
    if (status === 'paid' && transaction && transaction.workOrderId) {
      console.log(`💰 [PAYMENT] Updating WO ${transaction.workOrderId} to paid`);
      await dbAdapter.update('work_orders', transaction.workOrderId, {
        paymentStatus: 'paid',
        updatedAt: new Date().toISOString()
      });
      console.log(`✅ [PAYMENT] WO ${transaction.workOrderId} paymentStatus updated to paid`);
    }
    
    return result;
  } catch (error) {
    console.error('Error updating payment status:', error);
    throw new Error(error.message || 'Gagal mengupdate status pembayaran');
  }
},
  
  //DELETE
  delete: async (id) => dbAdapter.delete('transactions', id),
  
  //GET DASHBOARD STATS
  getDashboardStats: async () => {
    const transactions = await dbAdapter.get('transactions');
    const paid = transactions.filter(t => t.paymentStatus === 'paid');
    const pending = transactions.filter(t => t.paymentStatus === 'pending');
    
    const totalRevenue = paid.reduce((sum, t) => sum + (t.total || 0), 0);
    const totalPending = pending.reduce((sum, t) => sum + (t.total || 0), 0);
    
    return {
      totalTransactions: transactions.length,
      totalRevenue,
      totalPending,
      paidCount: paid.length,
      pendingCount: pending.length
    };
  },
  
  // SET FAILED
  setFailed: async (id, reason = '') => {
    const transaction = await dbAdapter.getById('transactions', id);
    if (!transaction) return null;
    
    // Return stock if already paid
    if (transaction.paymentStatus === 'paid') {
      for (const item of transaction.items) {
        try {
          const inventory = await inventoryService.getById(item.id);
          if (inventory) {
            await inventoryService.addStock(
              item.id, 
              item.quantity, 
              `Stock returned from failed transaction ${id}`
            );
          }
        } catch (error) {
          console.error('Error returning stock:', error);
        }
      }
    }
    
    return dbAdapter.update('transactions', id, {
      paymentStatus: 'failed',
      notes: (transaction.notes || '') + (reason ? ` | Failed reason: ${reason}` : ''),
      updatedAt: new Date().toISOString()
    });
  },

  // GET MONTHLY REVENUE
  getMonthlyRevenue: async (months = 6) => {
    const transactions = await dbAdapter.get('transactions');
    const paid = transactions.filter(t => t.paymentStatus === 'paid');
    
    const result = [];
    const now = new Date();
    for (let i = months - 1; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const month = date.getMonth();
      const year = date.getFullYear();
      
      const revenue = paid
        .filter(t => {
          const tDate = new Date(t.date);
          return tDate.getMonth() === month && tDate.getFullYear() === year;
        })
        .reduce((sum, t) => sum + (t.total || 0), 0);
      
      result.push({
        month: date.toLocaleString('id-ID', { month: 'short' }),
        revenue
      });
    }
    return result;
  }
};